import { renumberQuestions } from "../../../utils/surveySchema";

function validateBounds(question) {
    const details = question?.details || {};
    if (Number.isFinite(details.min) && Number.isFinite(details.max) && details.min > details.max) {
        console.warn(`Question "${question?.questionID}": min (${details.min}) > max (${details.max}). Swapping values.`);
        return { ...details, min: details.max, max: details.min };
    }
    return details;
}

// Recursively trim all strings in an object
function trimAllStrings(obj) {
    if (typeof obj === 'string') {
        return obj.trim();
    }
    if (Array.isArray(obj)) {
        return obj.map(trimAllStrings);
    }
    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, trimAllStrings(value)])
        );
    }
    return obj;
}

export function normalizeSurveyDropdownOptions(survey, enabledLangs = []) {
    if (!survey || typeof survey !== 'object') return survey;
    const next = { ...survey };
    const langs = enabledLangs.length
        ? enabledLangs.filter((l) => next && Object.prototype.hasOwnProperty.call(next, l))
        : Object.keys(next).filter((k) => next?.[k]?.questionnaire);
    langs.forEach((lng) => {
        const section = next?.[lng] || {};
        const qs = Array.isArray(section.questionnaire) ? section.questionnaire : [];
        const cleaned = qs.map((q) => {
            const details = q?.details || {};
            if (!details || typeof details !== 'object') return q;
            const hasSelect = Array.isArray(details.selectOptions);
            const hasDropdown = Array.isArray(details.dropdownOptions);
            if (!hasSelect && !hasDropdown) return q;
            const nextDetails = { ...details };
            if (!hasSelect && hasDropdown) {
                nextDetails.selectOptions = details.dropdownOptions;
            }
            delete nextDetails.dropdownOptions;
            return { ...q, details: nextDetails };
        });
        next[lng] = { ...section, questionnaire: cleaned };
    });
    return next;
}

export function prepareSurveyForPersist(survey, id, enabledLangs) {
    let prepared = normalizeSurveyDropdownOptions({ ...survey }, enabledLangs);

    // Trim all strings before processing
    prepared = trimAllStrings(prepared);

    const enabled = enabledLangs.filter((l) => prepared && Object.prototype.hasOwnProperty.call(prepared, l));
    enabled.forEach((lng) => {
        const section = prepared?.[lng] || {};
        const qs = Array.isArray(section.questionnaire) ? section.questionnaire : [];
        // Validate min <= max for all questions with bounds
        const validated = qs.map((q) => {
            const details = q?.details || {};
            if ((Number.isFinite(details.min) || Number.isFinite(details.max)) && details.min > details.max) {
                console.warn(`Question "${q?.questionID}": min (${details.min}) > max (${details.max}). Swapping values.`);
                return { ...q, details: { ...details, min: details.max, max: details.min } };
            }
            return q;
        });
        prepared[lng] = { ...section, questionnaire: renumberQuestions(validated) };
    });
    const sid = String(id);
    prepared.shortDescription = enabled.reduce((acc, lng) => ({ ...acc, [lng]: sid }), {});
    if (prepared.publishAt) prepared.publishDate = prepared.publishAt;
    prepared["language checked"] = !!prepared["language checked"];
    return prepared;
}

export function downloadJsonObject(obj, filename) {
    const blob = new Blob([JSON.stringify(obj, null, 2)], { type: 'application/json;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
